import { AdriverBannerId } from '@/components/Banners/Banners.constants';
import {
  BannerSource,
  SetBannerSource,
} from '@/store/useBannerStore/useBannerStore.types';

export function getBannerElements(bannerType: keyof typeof AdriverBannerId) {
  const banner = document.querySelector(`#${AdriverBannerId[bannerType]}`);

  const bannerIframe = document.querySelector(
    `#${AdriverBannerId[bannerType]} iframe`
  );

  return [banner, bannerIframe];
}

export function handleAndLoadBanner(
  bannerType: keyof typeof AdriverBannerId,
  setBannerSource: SetBannerSource,
  isAdManagerBannerVisible: boolean,
  onLoad: (bannerType: keyof typeof AdriverBannerId, loaded: boolean) => void
) {
  if (isAdManagerBannerVisible) {
    setBannerSource(BannerSource.Admanager);
    return;
  }
  const [banner, bannerIframe] = getBannerElements(bannerType);

  bannerIframe?.addEventListener('load', () => {
    if (banner?.clientHeight === 0) {
      setBannerSource(BannerSource.Admanager);
    } else {
      setBannerSource(BannerSource.Adriver);
    }

    onLoad(bannerType, Boolean(banner?.clientHeight));
  });
}

export function clearAdriverBgBanners() {
  const selectors = ['.lotriver-bg-left', '.lotriver-bg-right'];
  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(node => node.remove());
  });
}

export function dedupeAdriverBgBanner(banner: HTMLElement) {
  const selector = banner.classList.contains('lotriver-bg-left')
    ? '.lotriver-bg-left'
    : '.lotriver-bg-right';
  document.querySelectorAll(selector).forEach(node => {
    if (node !== banner) {
      node.remove();
    }
  });
}
